import React, { useEffect } from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/button';
import { DownloadIcon } from '@fiverr-private/visuals';
import { Box, theme } from '@fiverr-private/theme';
import { Stack } from '@fiverr-private/layout_components';

interface NoPreviewAvailableProps {
  downloadUrl: string;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
}

const NoPreviewAvailable = ({ downloadUrl, setError }: NoPreviewAvailableProps) => {
  useEffect(() => {
    setError?.(true);
  }, [setError]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      direction="column"
      alignItems="center"
      boxSizing="borderBox"
      backgroundColor="white"
      padding="8"
      gap="5"
      width={{ default: `calc(100vw - (${theme.spacing['3']}) * 2)`, sm: '480px' }}
      maxWidth="100%"
      borderRadius="xl"
      textAlign="center"
      wordBreak="breakAll"
    >
      <Stack justifyContent="center" direction="column" alignItems="center" gap="1">
        <h5>
          <I18n k="overlay.lightbox.noPreviewAvailable.title" />
        </h5>
      </Stack>
      <Stack justifyContent="center" direction="column" alignItems="center" gap="0">
        <Button size="sm" href={downloadUrl} variant="outline" target="_blank" download>
          <DownloadIcon />
          <I18n k="overlay.lightbox.noPreviewAvailable.download" />
        </Button>
      </Stack>
    </Box>
  );
};

export default NoPreviewAvailable;
